import React from "react";
import KeyAccountTable from "./KeyAccountTable/index"
import KeyAccountCreateDialog from "./KeyAccountCreateDialog/index"
import { getUserPreference } from "../../../utilities/common";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { TextField, Button, Grid, MenuItem, makeStyles, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { useToken, useAlert } from "../../../utilities/hooks";
import moment from 'moment';
import _ from "lodash";
import { getPartnerList } from "../../../actions/mmActions";
import AddBoxOutlined from '@material-ui/icons/AddBox';
import {
    searchKeyAccount,
} from "../../../actions/incidentManagementActions";
import { Autocomplete } from "@material-ui/lab";
import KeyAccountUpdateDialog from "./KeyAccountUpdateDialog";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    createButton: {
        marginTop: theme.spacing(2), // 调整上方间距
        marginLeft: 'auto',
        marginRight: theme.spacing(9),
        marginBottom: theme.spacing(-2), // 调整下方间距
    },
    grid: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'right',
        flexDirection: 'column',
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2), // 调整上方间距
        marginBottom: theme.spacing(-2), // 调整下方间距
    },
    firstgrid: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'right',
        flexDirection: 'column',
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2), // 调整上方间距
        marginBottom: theme.spacing(-2), // 调整下方间距
    },
    dateRangeRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(2)
    },
    textField: {
        width: '100%',
    },
    Button: {
        display: 'flex',
        alignItems: 'right',
        // marginRight: theme.spacing(16),
    },
}));
function IncidentKeyAccount() {
    const { t } = useTranslation('incidentmanagement');

    const [partnerList, setPartnerList] = useState([]);
    const [orderType, setOrderType] = useState(0);
    const alertDialog = useAlert();
    const dispatch = useDispatch();
    const classes = useStyles();
    const userPref = getUserPreference();
    const [selectedData, setSelectedData] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [detailedData, setDetailedData] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [timezone, setTimezone] = useState(0);
    const [name, setName] = useState(0);
    const [phone, setPhone] = useState(0);
    const [open, setOpen] = useState(false);

    const tokenContents = useToken();

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handlePhoneChange = (event) => {
        setPhone(event.target.value);
    };

    const handleNameClick = (rowData) => {
        setSelectedData(rowData);
        setIsDialogOpen(true);
    };

    const handleSearch = () => {
        setIsDataLoading(true);

        const params = {
            name: name ?? 0,
            phone: phone ?? 0,
            partner_id: orderType ?? 0,
        };

        dispatch(searchKeyAccount(params))
            .then((response) => {
                setDetailedData(response);
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('search_success'),
                    type: 'success'
                }));
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('search_failed'),
                    type: 'error'
                }));
                setDetailedData([]);  // Clear the table data
            })
            .finally(() => {
                setIsDataLoading(false);
                setName(0);
                setPhone(0);
            });
    };

    useEffect(() => {
        dispatch(getPartnerList()).then((res) => {
            setPartnerList(res);
        })
    }, []);

    return (
        <>
            <Grid container spacing={0} className={classes.container}>
                <Grid item xs={1.5} className={classes.firstgrid}>
                    <TextField
                        id="name"
                        className={classes.textField}
                        label={t("common:name")}
                        name="driverId"
                        variant="outlined"
                        onChange={handleNameChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={1.5} className={classes.grid}>
                    <TextField
                        id="phone_number_textfield"
                        className={classes.textField}
                        label={t("common:phone")}
                        name="driverId"
                        variant="outlined"
                        onChange={handlePhoneChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={2} className={classes.grid}>
                    {partnerList ? (
                        <Autocomplete
                            options={partnerList || []}
                            getOptionLabel={(option) => option?.name}
                            limitTags={1}
                            onChange={(event, value) => {
                                setOrderType(value?.id || 0);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={t("partner")} variant="outlined" />
                            )}
                            id="advancedsearch_autocomplete"
                            value={partnerList.find((option) => option.id === orderType) || 0}
                            fullWidth
                            margin="normal"
                        />
                    ) : null}
                </Grid>
                <Grid item xs={0.5} className={classes.grid}>
                    <Button
                        id='button-search'
                        variant="contained"
                        color="primary"
                        onClick={() => handleSearch()}
                    >
                        {t('common:search')}
                    </Button>
                </Grid>
                <Grid item className={classes.createButton}>
                    <Button
                        variant="contained"
                        color="default"
                        startIcon={<AddBoxOutlined />}
                        onClick={() => setOpen(true)}
                    >
                        {t('create_new')}
                    </Button>
                </Grid>
                <Grid item xs={12} >
                    <KeyAccountTable
                        data={detailedData}
                        isDataLoading={isDataLoading}
                        handleNameClick={handleNameClick} // Pass handleNameClick as a prop
                    />
                </Grid>
            </Grid>
            <KeyAccountCreateDialog
                open={open}
                onClose={() => setOpen(false)}
                partnerList={partnerList}
                handleNameClick={handleNameClick} // Pass handleNameClick as a prop
                handleSearch={handleSearch}
            />
            <KeyAccountUpdateDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                partnerList={partnerList}
                selectedData={selectedData}
                handleSearch={handleSearch}
            />
        </>
    );
}

export default IncidentKeyAccount
